import React from 'react'
import { Menubar } from 'primereact/menubar';
import { AuthContext } from '../../main/authProvider';
import PDVCaixaService from '../../app/service/contasAReceber/pdvCaixaService';
import HandleErrorService from '../../app/service/handleErrorService';
import * as popUp from '../toastr';
import UserMenu from './userMenu';
import MenuItem from './menuItem';
import NFService from '../../app/service/estoque/NFService';
import ConstantsUtil from '../../context/constantsUtil';

class MenuModulesbar extends React.Component {

    constructor(){
        super()
        this.pdvCaixaService = new PDVCaixaService()
        this.nfService = new NFService()
    }

    state = {
        urlCadastrarTipoDeRecebimento: '',
    }

    componentDidMount(){
        this.checaAlertas()
    }

    checaAlertas = () => {
        // this.checaAlertaFalhaImportacaoNFs()
    }

    render () {

        const goToLancamentoFechamentoCaixa = () => {
            this.pdvCaixaService.check()
            .then(respose => {
                if(respose.data){
                    window.location='/lancarFechamentoDeCaixa'
                } else{
                    popUp.noticePdvCaixaPopUp()
                }
            })
            .catch(error => {
                HandleErrorService.handleError(error)
            })
        }

        const goToCadastroTipoDeRecebimento = () => {
            this.pdvCaixaService.check()
            .then(respose => {
                if(respose.data){
                    window.location='/cadastrarTiposDeRecebimento'
                } else{
                    popUp.noticePdvCaixaPopUp()
                }
            })
            .catch(error => {
                HandleErrorService.handleError(error)
            })
        }

        const homeItem = {
            label: 'Home',
            icon: 'pi pi-fw pi-home',
            command: () => {
                window.location=ConstantsUtil.homePathname
            }
        }

        const menuItem = (item) => { 
            return (
                <MenuItem item={item}/>
            )
        }

        //Cadastros
        const produtosCadastrados = {
            label: 'Produtos',
            icon:"pi pi-search",
            url:"/searchProducts",
            disabled: this.context.perfil.isOperadorPagamentoDinheiro || this.context.perfil.isDiretor || this.context.perfil.isOperadorCego || this.context.perfil.isAlmoxarife,
            template: menuItem,
        }

        const pdvCaixa = { 
            label: 'Ponto de Venda (Caixa)',
            icon: 'pi pi-inbox',
            url: '/cadastrarPDVCaixa',
            disabled: this.context.perfil.isOperadorPagamentoDinheiro || this.context.perfil.isDiretor || this.context.perfil.isOperadorCego || this.context.perfil.isAlmoxarife,
            template: menuItem,
        }

        const tiposDeRecebimento = { 
            label: 'Tipos de Recebimento',
            command: goToCadastroTipoDeRecebimento,
            url: '/cadastrarTiposDeRecebimento',
            icon: 'pi pi-credit-card',
            disabled: this.context.perfil.isOperadorPagamentoDinheiro || this.context.perfil.isDiretor || this.context.perfil.isOperadorCego || this.context.perfil.isAlmoxarife,
            template: menuItem,
        }

        const fornecedores = { 
            label: 'Fornecedores',
            icon: 'pi pi-shopping-cart',
            url: '/fornecedores',
            disabled: this.context.perfil.isOperadorPagamentoDinheiro || this.context.perfil.isDiretor || this.context.perfil.isOperadorCego || this.context.perfil.isAlmoxarife,
            template: menuItem,
        }

        const gruposDePagamento = { 
            label: 'Grupos de Pagamento',
            icon: 'pi pi-sitemap',
            url: '/gruposDePagamento',
            disabled: this.context.perfil.isOperadorPagamentoDinheiro || this.context.perfil.isDiretor || this.context.perfil.isOperadorCego || this.context.perfil.isAlmoxarife,
            template: menuItem,
        }

        const tiposDePagamento = { 
            label: 'Tipos de Pagamento',
            icon: 'pi pi-wallet',
            url: '/tiposDePagamento',
            disabled: this.context.perfil.isOperadorPagamentoDinheiro || this.context.perfil.isDiretor || this.context.perfil.isOperadorCego || this.context.perfil.isAlmoxarife,
            template: menuItem,
        }

        const contasBancarias = {
            label: 'Contas Bancárias',
            icon: 'pi pi-dollar',
            url: '/cadastrarContaBancaria',
            disabled: this.context.perfil.isOperadorPagamentoDinheiro || this.context.perfil.isDiretor || this.context.perfil.isOperadorCego || this.context.perfil.isAlmoxarife,
            template: menuItem,
        }

        const aplicacaoFinanceira = {
            label: 'Aplicações Financeiras',
            icon: 'pi pi-percentage',
            url: '/aplicacaoFinanceira',
            disabled: this.context.perfil.isOperadorPagamentoDinheiro || this.context.perfil.isDiretor || this.context.perfil.isOperadorCego || this.context.perfil.isAlmoxarife,
            template: menuItem,
        }

        const planoDeContas = {
            label: 'Plano de Contas',
            icon: 'pi pi-file-excel',
            url: "/planoDeContas",
            disabled: this.context.perfil.isOperadorPagamentoDinheiro || this.context.perfil.isDiretor || this.context.perfil.isOperadorCego || this.context.perfil.isAlmoxarife,
            template: menuItem,
            
        }



        //Controle de Estoque
        const importarArquivos = { 
            label: 'Importar', 
            icon:"pi pi-upload",
            url:"/importacao",
            disabled: this.context.perfil.isOperadorPagamentoDinheiro || this.context.perfil.isDiretor || this.context.perfil.isOperadorCego || this.context.perfil.isAlmoxarife,
            template: menuItem,
        }

        const buscarNFePorChave = {
            label: 'NFe',
            icon: "pi pi-search",
            url: ConstantsUtil.buscarNFePorChavePathName,
            template: menuItem,
        }

        const buscarNFSePorChave = {
            label: 'NFSe',
            icon: "pi pi-search",
            url: ConstantsUtil.buscarNFSePorChavePathName,
            template: menuItem,
        }

        const buscarNFPorChave = {
            label: 'Buscar NF por chave',
            items: [
                buscarNFePorChave,
                buscarNFSePorChave,
            ],
            // disabled: this.context.perfil.isDiretor || this.context.perfil.isOperadorCego || this.context.perfil.isAlmoxarife,
            template: menuItem,
        }

        const historicoImportacaoArquivos = { 
            label: 'Histórico', 
            icon:"pi pi-undo",
            url: ConstantsUtil.historicoImportacaoNFsPathname,
            // disabled: !this.context.perfil.isAdmin,
            template: menuItem,
        }

        const syncVendas = { 
            label: 'Sincronizar NFs de Venda', 
            icon:"pi pi-link",
            url: ConstantsUtil.syncImportacaoNFsVendaPathname,
            disabled: this.context.perfil.isOperadorPagamentoDinheiro || !this.context.perfil.isAdmin,
            template: menuItem,
        }

        const importacaoArquivos = { 
            label: 'Importação de NFs', 
            items: [
                importarArquivos,
                buscarNFPorChave,
                syncVendas,
                historicoImportacaoArquivos
            ],
            disabled: this.context.perfil.isOperadorPagamentoDinheiro || this.context.perfil.isDiretor || this.context.perfil.isOperadorCego || this.context.perfil.isAlmoxarife,
            template: menuItem,
        }

        const lancarInventario = {
            label: 'Lançar',
            icon:"pi pi-pencil",
            url: ConstantsUtil.lancarInventarioPathname,
            disabled: this.context.perfil.isOperadorPagamentoDinheiro || this.context.perfil.isDiretor || this.context.perfil.isOperadorCego || this.context.perfil.isAlmoxarife,
            template: menuItem,
        }

        const conferirLancamentoInventario = {
            label: 'Conferir',
            icon:"pi pi-eye",
            url: ConstantsUtil.conferirLancamentoInventarioPathname,
            disabled: this.context.perfil.isOperadorPagamentoDinheiro || this.context.perfil.isDiretor || this.context.perfil.isOperadorCego || this.context.perfil.isAlmoxarife,
            template: menuItem,
        }

        const lancamentoInventario = {
            label: 'Lançamento de Inventário',
            items: [
                lancarInventario,
                conferirLancamentoInventario
            ],
            disabled: this.context.perfil.isOperadorPagamentoDinheiro || this.context.perfil.isDiretor || this.context.perfil.isOperadorCego || this.context.perfil.isAlmoxarife,
            template: menuItem,
        }

        const preValidacaoNFEntrada = {
            label: 'Pré-Validação',
            icon:"pi pi-check",
            url: ConstantsUtil.preValidacaoNFsEntrada,
            disabled: this.context.perfil.isOperadorPagamentoDinheiro || this.context.perfil.isOperadorCego || this.context.perfil.isAlmoxarife || !this.context.configuracaoEmpresa.possuiPreValidacaoNFsEntrada,
            template: menuItem,
        }        

        const validacaoNFEntrada = {
            label: 'Validação',
            icon:"pi pi-check",
            url: ConstantsUtil.validacaoNFsEntrada,
            disabled: this.context.perfil.isOperadorPagamentoDinheiro || this.context.perfil.isOperadorCego,
            template: menuItem,
        }        

        const NFEntrada = {
            label: 'NFs de Entrada (Mercadoria)',
            items: [
                preValidacaoNFEntrada,
                validacaoNFEntrada
            ],
            disabled: this.context.perfil.isOperadorPagamentoDinheiro,
            template: menuItem,
        }

        const validarNFsServico = {
            label: 'Validar NFSe (Serviço)',
            icon:"pi pi-check",
            url:"/validacaoNFsServico",
            disabled: this.context.perfil.isOperadorPagamentoDinheiro || this.context.perfil.isDiretor || this.context.perfil.isOperadorCego || this.context.perfil.isAlmoxarife,
            template: menuItem,
        }

        const validarPedidosCompra = {
            label: 'Listar',
            icon:"pi pi-check",
            url:"/validacaoPedidosCompra",
            disabled: this.context.perfil.isOperadorPagamentoDinheiro || this.context.perfil.isOperadorCego,
            template: menuItem,
        }

        const importarPedidosCompra = {
            label: 'Importar',
            icon:"pi pi-upload",
            url: ConstantsUtil.importarPedidosCompraPathname,
            disabled: this.context.perfil.isOperadorPagamentoDinheiro || this.context.perfil.isDiretor || this.context.perfil.isOperadorCego || this.context.perfil.isAlmoxarife,
            template: menuItem,
        }

        const pedidosCompra = {
            label: 'Pedidos de Compra',
            items: [
                importarPedidosCompra,
                validarPedidosCompra
            ],
            disabled: this.context.perfil.isOperadorPagamentoDinheiro || this.context.perfil.isOperadorCego,
            template: menuItem,            
        }

        const parametrizacaoProdutos = {
            label: 'Produtos de Compra',
            icon:"pi pi-box",
            url:"/parameterize",
            disabled: this.context.perfil.isOperadorPagamentoDinheiro || this.context.perfil.isDiretor || this.context.perfil.isOperadorCego || this.context.perfil.isAlmoxarife,
            template: menuItem,
        }

        const conferenciaNFMercadoria = {
            label: 'Mercadoria',
            icon:"pi pi-box",
            url:"/conferenciaNF",
            disabled: this.context.perfil.isOperadorPagamentoDinheiro || this.context.perfil.isOperadorCego,
            template: menuItem,
        }

        const conferenciaNFServico = {
            label: 'Serviço',
            icon:"pi pi-book",
            url: ConstantsUtil.conferenciaNFServico,
            disabled: this.context.perfil.isOperadorPagamentoDinheiro || this.context.perfil.isOperadorCego || this.context.perfil.isAlmoxarife,
            template: menuItem,
        }


        const conferenciaNF = {
            label: 'Conferência de NFs',
            items: [
                conferenciaNFMercadoria,
                conferenciaNFServico
            ],
            disabled: this.context.perfil.isOperadorPagamentoDinheiro || this.context.perfil.isOperadorCego,
            template: menuItem,
        }

        const lancamentoManualNF = {
            label: 'Lançamento Manual de NF',
            icon:"pi pi-pencil",
            url: ConstantsUtil.lancamentoManualNFPathName,
            disabled: this.context.perfil.isOperadorPagamentoDinheiro || this.context.perfil.isDiretor || this.context.perfil.isOperadorCego || this.context.perfil.isAlmoxarife,
            template: menuItem,
        }



        //Lançamentos
        const lancarFechamentoDeCaixa = {   
            label: 'Lançar', icon: 'pi pi-pencil',
            command: goToLancamentoFechamentoCaixa,
            url: "/lancarFechamentoDeCaixa",
            disabled: this.context.perfil.isOperadorPagamentoDinheiro || this.context.perfil.isDiretor,
            template: menuItem,
        }

        const reprocessarFechamentoDeCaixa = {
            label: 'Reprocessar', icon: 'pi pi-refresh',
            // command: () => {window.location="/reprocessarLancamentosFechamentoDeCaixa"},
            url:"/reprocessarLancamentosFechamentoDeCaixa",
            disabled: this.context.perfil.isOperadorPagamentoDinheiro || !this.context.perfil.isAdmin,
            template: menuItem,
       }
       
        const buscarFechamentoDeCaixaAdministradoras = {
            label: 'Buscar das Administradoras', icon: 'pi pi-search',
            url: ConstantsUtil.buscarFechamentoDeCaixaAdministradorasPathname,
            // disabled: this.context.perfil.isOperadorPagamentoDinheiro || !this.context.perfil.isAdmin,
            template: menuItem,
            disabled: this.context.perfil.isOperadorPagamentoDinheiro || this.context.perfil.isOperadorCego
       }

        const calcularPDV = {
            label: 'Calcular PDV', icon: 'pi pi-chart-bar',
            url: ConstantsUtil.calcularPDVPathname,
            // disabled: this.context.perfil.isOperadorPagamentoDinheiro || !this.context.perfil.isAdmin,
            template: menuItem,
            disabled: this.context.perfil.isOperadorPagamentoDinheiro || this.context.perfil.isOperadorCego
       }

       const fechamentoDeCaixa = {
            label: 'Fechamento de Caixa',
            items: [
                lancarFechamentoDeCaixa,
                reprocessarFechamentoDeCaixa,
                buscarFechamentoDeCaixaAdministradoras,
                calcularPDV
            ],
            disabled: this.context.perfil.isOperadorPagamentoDinheiro || this.context.perfil.isDiretor || this.context.perfil.isAlmoxarife,
            template: menuItem,
        }

        const implantacao = {
            label: 'Implantação de Saldo',
            icon: 'pi pi-pencil',
            url:"/implantacaoSaldo",
            disabled: this.context.perfil.isOperadorPagamentoDinheiro || this.context.perfil.isOperador || this.context.perfil.isOperadorCego || this.context.perfil.isAlmoxarife || this.context.perfil.isDiretor,
            template: menuItem,
        }

        const lancamentoBancario = {
            label: this.context.perfil.isOperadorPagamentoDinheiro || this.context.perfil.isDiretor ? 'Lançamento de Cofre' : 'Lançamento Bancário',
            icon: 'pi pi-pencil',
            url: "/lancarFechamentoBancario",
            disabled: this.context.perfil.isOperadorCego || this.context.perfil.isAlmoxarife,
            template: menuItem,
        }

        const boletos = {
            label: 'Boletos',
            icon: 'pi pi-book',
            url: ConstantsUtil.boletosPathname,
            disabled: this.context.perfil.isOperadorPagamentoDinheiro || this.context.perfil.isDiretor || this.context.perfil.isOperadorCego || this.context.perfil.isAlmoxarife,
            template: menuItem,            
        }

        const lancarProvisoesAPagarIndividual = {
            label: 'Individual',
            icon: 'pi pi-pencil',
            url: ConstantsUtil.lancarProvisoesAPagarPathname,
            disabled: this.context.perfil.isOperadorPagamentoDinheiro || this.context.perfil.isDiretor || this.context.perfil.isOperadorCego || this.context.perfil.isAlmoxarife,
            template: menuItem,
        }

        const lancarProvisoesAPagarRecorrencia = {
            label: 'Recorrência/Estimativa',
            icon: 'pi pi-refresh',
            url: ConstantsUtil.lancarProvisoesRecorrentesPathName,
            disabled: this.context.perfil.isOperadorPagamentoDinheiro || this.context.perfil.isDiretor || this.context.perfil.isOperadorCego || this.context.perfil.isAlmoxarife,
            template: menuItem,
        }

        const importarFolhaDePagamento = {
            label: 'Importar Folha de Pagamento',
            icon: 'pi pi-upload',
            url: ConstantsUtil.provisionarFolhaDePagamentoPathName,
            disabled: this.context.perfil.isOperadorPagamentoDinheiro || this.context.perfil.isDiretor || this.context.perfil.isOperadorCego || this.context.perfil.isAlmoxarife,
            template: menuItem,
        }

        const lancarProvisoesAPagar = {
            label: 'Lançar',
            items:[
                lancarProvisoesAPagarIndividual,
                lancarProvisoesAPagarRecorrencia,
                importarFolhaDePagamento
            ],
            disabled: this.context.perfil.isOperadorPagamentoDinheiro || this.context.perfil.isDiretor || this.context.perfil.isOperadorCego || this.context.perfil.isAlmoxarife,
            template: menuItem,
        }

        const conferirProvisoesAPagar = {
            label: 'Conferir',
            icon: 'pi pi-eye',
            url:"/checkProvisoesAPagar",
            disabled: this.context.perfil.isOperadorPagamentoDinheiro || this.context.perfil.isDiretor || this.context.perfil.isOperadorCego || this.context.perfil.isAlmoxarife,
            template: menuItem,
        }

        const provisoesAPagar = {
            label: 'Provisões a pagar',
            items:[
                lancarProvisoesAPagar,
                conferirProvisoesAPagar
            ],
            disabled: this.context.perfil.isOperadorPagamentoDinheiro || this.context.perfil.isOperadorCego || this.context.perfil.isAlmoxarife || this.context.perfil.isDiretor,
            template: menuItem,
        }

        const provisoesAReceber = {
            label: 'Provisões a receber',
            icon: 'pi pi-pencil',
            url: ConstantsUtil.lancarProvisoesAReceberPathname,
            disabled: this.context.perfil.isOperadorPagamentoDinheiro || this.context.perfil.isOperadorCego || this.context.perfil.isAlmoxarife || this.context.perfil.isDiretor,
            template: menuItem,
        }

        const valorDeEstoque = {
            label: 'Valor de Estoque',
            disabled: this.context.perfil.isOperadorPagamentoDinheiro || this.context.perfil.isOperadorCego || this.context.perfil.isAlmoxarife || this.context.perfil.isDiretor,
            icon: 'pi pi-pencil',
            url: ConstantsUtil.valorDeEstoquePathname,
            template: menuItem,
        }

        const receitaServico = {
            label: 'Receita de Serviço',
            disabled: this.context.perfil.isOperadorPagamentoDinheiro || this.context.perfil.isOperadorCego || this.context.perfil.isAlmoxarife || !this.context.configuracaoEmpresa.receitaDeServicos,
            icon: 'pi pi-pencil',
            url: ConstantsUtil.receitaServicoPathname,
            template: menuItem,
        }

        const reprocessLivroDiario = {
            label: 'Reprocessar Livro Diário',
            icon: 'pi pi-refresh',
            url: "/reprocessarLivroDiario",
            disabled: this.context.perfil.isOperadorPagamentoDinheiro || true,
            template: menuItem,
        }



        //Conas a receber
        const fichaBancaria = { 
            label: this.context.perfil.isOperadorPagamentoDinheiro ? 'Relatório de Cofre' : 'Ficha Bancária',
            icon: 'pi pi-dollar',
            // command: () => {
            //     window.location="/fichaBancaria"
            // },
            url: "/fichaBancaria",
            disabled: this.context.perfil.isOperadorCego || this.context.perfil.isAlmoxarife
        }



        //Contas a Pagar
        // const livroRazao = { 
        //     label: 'Livro Razão',
        //     // icon: 'pi pi-book',
        // }


        //Relatórios
        const fechamentoCaixa = { 
            label: 'Fechamento de Caixa',
            icon: 'pi pi-book',
            // command: () => {
            //     window.location="/fichaDeRecebimento"
            // },
            url: "/relatorioFechamentoCaixa",
            disabled: this.context.perfil.isOperadorPagamentoDinheiro || this.context.perfil.isOperadorCego || this.context.perfil.isAlmoxarife
        }

        const fichaDeRecebimentoIndividual = { 
            label: 'Individual',
            icon: 'pi pi-book',
            // command: () => {
            //     window.location="/fichaDeRecebimento"
            // },
            url: "/fichaDeRecebimento",
            disabled: this.context.perfil.isOperadorPagamentoDinheiro || this.context.perfil.isOperadorCego || this.context.perfil.isAlmoxarife
        }

        const fichaDeRecebimentoConsolidada = {
            label: 'Consolidada',
            icon: 'pi pi-book',
            url: "/fichaDeRecebimentoConsolidada",
            disabled: this.context.perfil.isOperadorPagamentoDinheiro || this.context.perfil.isOperadorCego || this.context.perfil.isAlmoxarife
        }

        const fichaDeRecebimento = {
            label: 'Ficha de Recebimento (Cartões)',
            items: [
                fichaDeRecebimentoIndividual,
                fichaDeRecebimentoConsolidada,
            ],
            disabled: this.context.perfil.isOperadorPagamentoDinheiro || this.context.perfil.isOperadorCego || this.context.perfil.isAlmoxarife
        }

        const fichaDeRecebimentoBoletos = {
            label: 'Ficha de Recebimento (Boletos)',
            url: ConstantsUtil.fichaDeRecebimentoBoletosPathname,
            // items: [
            //     fichaDeRecebimentoIndividual,
            //     fichaDeRecebimentoConsolidada,
            // ],
            disabled: this.context.perfil.isOperadorPagamentoDinheiro || this.context.perfil.isOperadorCego || this.context.perfil.isAlmoxarife
        }

        const fichaDePagamento = {
            label: 'Ficha de Pagamento',
            icon: 'pi pi-book',
            url: ConstantsUtil.fichaDePagamentoPathname,
            disabled: this.context.perfil.isOperadorPagamentoDinheiro || this.context.perfil.isOperadorCego || this.context.perfil.isAlmoxarife
        }

        const conciliacaoBancaria = {
            label: 'Conciliação Bancária',
            icon: 'pi pi-link',
            url: ConstantsUtil.conciliacaoBancariaPathname,
            disabled: this.context.perfil.isOperadorPagamentoDinheiro || this.context.perfil.isOperadorCego || this.context.perfil.isAlmoxarife
        }

        const livroRazao = {
            label: 'Livro Razão',
            icon: 'pi pi-book',
            url: "/livroRazao",
            disabled: this.context.perfil.isOperadorPagamentoDinheiro || this.context.perfil.isOperadorCego || this.context.perfil.isAlmoxarife
        }

        const DREMensal = {
            label: 'Mensal',
            icon: 'pi pi-book',
            url: "/fluxoDeCaixa",
            disabled: this.context.perfil.isOperadorPagamentoDinheiro || this.context.perfil.isOperadorCego || this.context.perfil.isAlmoxarife
        }

        const DREConsolidado = {
            label: 'Consolidado',
            icon: 'pi pi-book',
            url: "/fluxoDeCaixaConsolidado",
            disabled: this.context.perfil.isOperadorPagamentoDinheiro || this.context.perfil.isOperadorCego || this.context.perfil.isAlmoxarife
        }

        const DRE = {
            label: 'Fluxo de Caixa Realizado',
            items: [
                DREMensal,
                DREConsolidado,
            ],
            disabled: this.context.perfil.isOperadorPagamentoDinheiro || this.context.perfil.isOperadorCego || this.context.perfil.isAlmoxarife
        }

        const DRECompetenciaMensal = {
            label: 'Mensal',
            icon: 'pi pi-book',
            url: "/DRECompetenciaMensal",
            disabled: this.context.perfil.isOperadorPagamentoDinheiro || this.context.perfil.isOperadorCego || this.context.perfil.isAlmoxarife
        }

        const DRECompetenciaConsolidado = {
            label: 'Consolidado',
            icon: 'pi pi-book',
            url: "/DRECompetenciaConsolidado",
            disabled: this.context.perfil.isOperadorPagamentoDinheiro || true
        }

        const DRECompetencia = {
            label: 'DRE Por Competência',
            items: [
                DRECompetenciaMensal,
                DRECompetenciaConsolidado,
            ],
            disabled: this.context.perfil.isOperadorPagamentoDinheiro || this.context.perfil.isOperadorCego || this.context.perfil.isAlmoxarife
        }


        const fluxoDeCaixaPrevisto = {
            label: 'Fluxo de Caixa Previsto',
            icon: 'pi pi-book',
            url: "/fluxoDeCaixaPrevisto",
            disabled: this.context.perfil.isOperadorPagamentoDinheiro || this.context.perfil.isOperadorCego || this.context.perfil.isAlmoxarife
        }

        const fichaDeEstoque = {
            label: 'Ficha de Estoque',
            icon: 'pi pi-box',
            url: "/fichaDeEstoque",
            disabled: this.context.perfil.isOperadorPagamentoDinheiro || this.context.perfil.isOperadorCego || this.context.perfil.isAlmoxarife
        }

        const inflacaoProdutosCompra = {
            label: 'Inflação de Produtos de Compra',
            icon: 'pi pi-chart-line',
            url: ConstantsUtil.inflacaoProdutosCompraPathName,
            disabled: this.context.perfil.isOperadorPagamentoDinheiro || this.context.perfil.isOperadorCego || this.context.perfil.isAlmoxarife
        }

        const folhaDePagamento = {
            label: 'Folha de Pagamento',
            icon: 'pi pi-book',
            url: ConstantsUtil.folhaDePagamentoPathName,
            disabled: this.context.perfil.isOperadorPagamentoDinheiro || this.context.perfil.isOperadorCego || this.context.perfil.isAlmoxarife
        }

        const ddaBoletoPagamento = {
            label: 'DDA Boletos',
            icon: 'pi pi-book',
            url: ConstantsUtil.ddaBoletosPagamentoPathName,
            disabled: this.context.perfil.isOperadorCego || this.context.perfil.isAlmoxarife
        }


        //Painel
        // const noLoggedItems = [
        //     homeItem
        // ]

        const loggedItems = [

            homeItem,
            
            {
                label: 'Cadastros',
                icon: 'pi pi-plus',
                items: [
                    produtosCadastrados,
                    pdvCaixa,
                    contasBancarias,
                    aplicacaoFinanceira,
                    tiposDeRecebimento,
                    tiposDePagamento,
                    fornecedores,
                    gruposDePagamento,
                    // planoDeContas
                ]
            },
            {
                label: 'Controle de Estoque', icon: 'pi pi-box',
                items: [
                    importacaoArquivos,
                    NFEntrada,
                    validarNFsServico,
                    pedidosCompra,
                    lancamentoInventario,
                    parametrizacaoProdutos,
                    conferenciaNF,
                    lancamentoManualNF,
                ]
            },
            {
                label: 'Lançamentos', icon: 'pi pi-chart-line',
                items: [
                    implantacao,
                    fechamentoDeCaixa,
                    lancamentoBancario,
                    boletos,
                    reprocessLivroDiario,
                    provisoesAPagar,
                    provisoesAReceber,
                    valorDeEstoque,
                    receitaServico,
                ]
            },
            {
                label: 'Relatórios', icon: 'pi pi-book',
                items:
                [
                    fechamentoCaixa,
                    fichaDeRecebimento,
                    fichaDeRecebimentoBoletos,
                    fichaDePagamento,
                    conciliacaoBancaria,
                    fichaBancaria,
                    // livroRazao,
                    DRE,
                    fluxoDeCaixaPrevisto,
                    DRECompetencia,
                    fichaDeEstoque,
                    inflacaoProdutosCompra,
                    folhaDePagamento,
                    ddaBoletoPagamento,
                ]
            },
        ];

        const chooseItems = () => {
            return this.context.isAuth ? loggedItems : []
        }
        
        const end = <UserMenu 
            context = {this.context}
        />

        const renderIfLogged = () => {
            if(!window.location.pathname.includes('/login')){
                return (
                    <>
                    <div>
                        <div className="card"
                        
                        >
                            <Menubar
                                model={chooseItems()}
                                end={end} 
                                // style={{zIndex:2}}
                                style={{ zIndex: 2, height: '2.8rem', fontSize: '0.8rem' }} // obs: zIndex setado para dropdown sobrepor labels do mui
                            /> 
                        </div>
                    </div>                    
                    </>
                )
            }
        }

        return (
            <>
                {renderIfLogged()}
            </>
        )
    }
}

MenuModulesbar.contextType = AuthContext

export default MenuModulesbar